module.exports = __webpack_public_path__ + "img/20110201_03.44fc6520.jpg";